// extracted by mini-css-extract-plugin
export var faq = "faq-module--faq--e5ff1";